import { render, staticRenderFns } from "./issues-handling.vue?vue&type=template&id=04464a7a&scoped=true&"
import script from "./issues-handling.vue?vue&type=script&lang=js&"
export * from "./issues-handling.vue?vue&type=script&lang=js&"
import style0 from "./issues-handling.vue?vue&type=style&index=0&lang=css&"
import style1 from "./issues-handling.vue?vue&type=style&index=1&id=04464a7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04464a7a",
  null
  
)

export default component.exports